export default "/images/6562fbe7ef5e5d986ffe94971a6eb26d.png";